export default function BusinessTrustedAtScale() {
  return (
    <section
      id="business-trusted-at-scale"
      className="w-full bg-black font-fira text-white"
    >
      <div className="relative w-full overflow-hidden">
        <img
          src="/business/b2bld.webp"
          alt=""
          className="pointer-events-none absolute inset-0 hidden h-full w-full object-cover object-center md:block"
          loading="lazy"
          decoding="async"
        />
        <img
          src="/business/b2blm.webp"
          alt=""
          className="pointer-events-none absolute inset-0 block h-full w-full object-cover object-center md:hidden"
          loading="lazy"
          decoding="async"
        />

        <div className="relative z-10 mx-auto flex w-[90%] flex-col items-center text-center md:w-[80%]">
          <p className="pt-12 font-fira text-sm font-normal uppercase tracking-[0.18em] text-[#FFFFFF] md:pt-16 lg:pt-20">
            Trusted at scale
          </p>

          <div className="aspect-[4/3] w-full md:aspect-[16/7]" aria-hidden="true" />

          <p className="max-w-md pb-12 font-fira text-sm font-normal leading-relaxed text-[#FFFFFF85] md:max-w-2xl md:pb-16 md:text-base lg:pb-20">
            Learners trained through the newsletter, videos.
            <br />
            Founders, and the people building with AI.
          </p>
        </div>
      </div>
    </section>
  );
}
